import { Toast, Typography } from '@one-thd/sui-atomic-components';
import { Checkmark, ErrorFilled } from '@one-thd/sui-icons';
import React, { useState } from 'react';
import { IOrderDetailsResponse } from '../../../models/order-details';
import { IPoJobNameButton } from '../../../models/purchase-history/table';
import {
  getEffectiveOrderNumber,
  isPoJobNameEmpty,
} from '../../../utils/general';
import { PO_JOB_NAME_PLACEHOLDER } from '../../../constants/general';
import { PoJobNameModal } from './index';

export const PoJobNameButton = ({ order }: IPoJobNameButton) => {
  const effectiveOrderNumber = getEffectiveOrderNumber(order);

  const initPoJobName = isPoJobNameEmpty(order?.POJobName, effectiveOrderNumber)
    ? PO_JOB_NAME_PLACEHOLDER
    : order?.POJobName;

  const [openModal, setOpenModal] = useState(false);
  const [visiblePoJobName, setVisiblePoJobName] = useState<string>(
    initPoJobName ?? '',
  );
  const [toastState, setToastState] = useState<{
    open: boolean;
    message?: string;
    status?: 'success' | 'error';
  }>({ open: false });

  const showToast = (message: string, status: 'success' | 'error') =>
    setToastState({ open: true, message, status });

  return (
    <>
      <button
        type="button"
        className="sui-underline sui-text-sm hover:sui-no-underline sui-text-ellipsis sui-overflow-hidden sui-h-[44px] sui-text-left sui-w-[124px]"
        onClick={() => setOpenModal(true)}
      >
        <Typography variant="body-base">
          {visiblePoJobName?.length > 15
            ? `${visiblePoJobName?.slice(0, 12)}...`
            : visiblePoJobName}
        </Typography>
      </button>
      <Toast
        open={toastState.open}
        onClose={() => setToastState((prev) => ({ ...prev, open: false }))}
        message={toastState.message ?? ''}
        decoration={
          toastState.status === 'error' ? <ErrorFilled /> : <Checkmark />
        }
        showCloseButton
      />
      {openModal && (
        <PoJobNameModal
          resolvedOrderNumber={effectiveOrderNumber}
          page="purchaseHistory"
          order={order as unknown as IOrderDetailsResponse}
          openModal={openModal}
          setOpenModal={setOpenModal}
          visiblePoJobName={visiblePoJobName}
          setVisiblePoJobName={setVisiblePoJobName}
          onToast={showToast}
        />
      )}
    </>
  );
};
